import 'core-js/modules/es6.reflect.construct';
import _classCallCheck from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck';
import _createClass from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/createClass';
import _inherits from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/inherits';
import _possibleConstructorReturn from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf';
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module image/image/imageediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ImageLoadObserver from './imageloadobserver';
import {
    viewFigureToModel,
    modelToViewAttributeConverter,
    srcsetAttributeConverter
} from './converters';
import { toImageWidget } from './utils';
import ImageInsertCommand from './imageinsertcommand';
/**
 * The image engine plugin.
 *
 * It registers:
 *
 * * `<image>` as a block element in the document schema, and allows `alt`, `src` and `srcset` attributes.
 * * converters for editing and data pipelines.
 * * `'imageInsert'` command.
 *
 * @extends module:core/plugin~Plugin
 */
var ImageEditing = /*#__PURE__*/
function (_Plugin) {
    _inherits(ImageEditing, _Plugin);
    var _super = _createSuper(ImageEditing);
    function ImageEditing() {
        _classCallCheck(this, ImageEditing);
        return _super.apply(this, arguments);
    }
    _createClass(ImageEditing, [{
            key: 'init',
            value: /**
     * @inheritDoc
     */
            function init() {
                var editor = this.editor;
                var schema = editor.model.schema;
                var t = editor.t;
                var conversion = editor.conversion;
                // See https://github.com/ckeditor/ckeditor5-image/issues/142.
                editor.editing.view.addObserver(ImageLoadObserver);
                // Configure schema.
                schema.register('image', {
                    isObject: true,
                    isBlock: true,
                    allowWhere: '$block',
                    allowAttributes: [
                        'alt',
                        'src',
                        'srcset'
                    ]
                });
                conversion.for('dataDowncast').elementToElement({
                    model: 'image',
                    view: function view(modelElement, viewWriter) {
                        return createImageViewElement(viewWriter);
                    }
                });
                conversion.for('editingDowncast').elementToElement({
                    model: 'image',
                    view: function view(modelElement, viewWriter) {
                        return toImageWidget(createImageViewElement(viewWriter), viewWriter, t('image widget'));
                    }
                });
                conversion.for('downcast').add(modelToViewAttributeConverter('src')).add(modelToViewAttributeConverter('alt')).add(srcsetAttributeConverter());
                conversion.for('upcast').elementToElement({
                    view: {
                        name: 'img',
                        attributes: { src: true }
                    },
                    model: function model(viewImage, modelWriter) {
                        return modelWriter.createElement('image', { src: viewImage.getAttribute('src') });
                    }
                }).attributeToAttribute({
                    view: {
                        name: 'img',
                        key: 'alt'
                    },
                    model: 'alt'
                }).attributeToAttribute({
                    view: {
                        name: 'img',
                        key: 'srcset'
                    },
                    model: {
                        key: 'srcset',
                        value: function value(viewImage) {
                            var value = { data: viewImage.getAttribute('srcset') };
                            if (viewImage.hasAttribute('width')) {
                                value.width = viewImage.getAttribute('width');
                            }
                            return value;
                        }
                    }
                }).add(viewFigureToModel());
                // Register imageUpload command.
                editor.commands.add('imageInsert', new ImageInsertCommand(editor));
            }
        }], [{
            key: 'pluginName',
            get: /**
     * @inheritDoc
     */
            function get() {
                return 'ImageEditing';
            }
        }]);
    return ImageEditing;
}(Plugin);
// Creates a view element representing the image.
//
//		<figure class="image"><img></img></figure>
//
// Note that `alt` and `src` attributes are converted separately, so they are not included.
//
// @private
// @param {module:engine/view/downcastwriter~DowncastWriter} writer
// @returns {module:engine/view/containerelement~ContainerElement}
export {
    ImageEditing as default
};
export function createImageViewElement(writer) {
    var emptyElement = writer.createEmptyElement('img');
    var figure = writer.createContainerElement('figure', { class: 'image' });
    writer.insert(writer.createPositionAt(figure, 0), emptyElement);
    return figure;
}